import { Observable } from "rxjs";
import { BaseService } from "./base.service";
import { Injectable } from "@angular/core";
import { EstruturaRetornoDadosOutputDto } from "../domain/DTOs/output/estrutura-retorno-dados.output.dto";
import { BancoNoticiasOutputDto } from "../domain/DTOs/output/banco-noticias.output.dto";

@Injectable()
export class BancoNoticiasService {

  constructor(private readonly baseService: BaseService) {}

  public obterBancoNoticias(
    inputDto: string
  ): Observable<EstruturaRetornoDadosOutputDto<BancoNoticiasOutputDto[]>> {
    return this.baseService.get(
      `BancoNoticias/ObterBancoNoticias?categoria=${inputDto}`
    );
  }

  public obterArquivoPdfNoticia(
    inputDto: string
  ): Observable<EstruturaRetornoDadosOutputDto<string>> {
    return this.baseService.get(
      `BancoNoticias/ObterArquivoPdfNoticia?nomeArquivo=${inputDto}`
    )
  }
}
